import React from 'react';
import ImageItem from '@/pages/company/WorkspaceRoute/components/webtwain/components/ImageItem';

const ImageViewer = ({ list, itemClass, onMouseDown, selectedList, showImageInPopup }) => (
  <>
    {list.map((image) => (
      <ImageItem
        key={image.initialIndex}
        image={image}
        className={itemClass}
        onMouseDown={onMouseDown}
        showImageInPopup={showImageInPopup}
        selected={selectedList.contains(image.initialIndex)}
      />
    ))}
  </>
);

export default ImageViewer;
